module.exports = __webpack_public_path__ + "static/media/yellow-l.bf1cf69c.svg";